import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss']
})
export class PhoneComponent {
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();

  updatePhoneNumber(value: string) {
    this.feature.value = value;
    this.featureChange.emit(this.feature);
  }

  // You might want to add phone number validation here
  isValidPhoneNumber(phoneNumber: string): boolean {
    // This is a basic regex for international phone numbers
    // You might want to adjust it based on your specific requirements
    const phoneRegex = /^\+?([0-9]{1,3})?[-. (]?([0-9]{1,4})[-. )]?([0-9]{1,4})[-. ]?([0-9]{1,9})$/;
    return phoneRegex.test(phoneNumber);
  }
}